<template>
  <v-app>
    <app-toolbar></app-toolbar>
    <v-content>
      <v-container fluid>
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-content>
    <v-dialog v-model="loading" hide-overlay persistent lazy width="300">
      <v-card color="primary" dark>
        <v-card-text><v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear></v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="notification.show" :color="notification.color" :timeout="notification.timeout" :multi-line="notification.multiline">
      {{ notification.text }}
      <v-btn dark flat @click="notification.show = false">
        <v-icon small>close</v-icon>
      </v-btn>
    </v-snackbar>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import AppFooter from './components/AppFooter'
import AppToolbar from './components/AppToolbar'

  export default {
    name: 'App',
    components:{
      AppToolbar, AppFooter
    },
    data: () => ({
      loading: false,
      notification: {
        show: false,
        color: 'error',
        timeout: 5000,
        text: 'Some notification here',
        multiline: false
      }
    }),
    mounted () {
      EventBus.$on('send-notification', not => { // show notification to user
        if(this.notification.show) this.notification.show = false;
        setTimeout(() => {
          not.show = true;
          not.timeout = 5000;
          if(not.color === undefined)
            not.color = 'error';
          if(not.multiline === undefined)
            not.multiline = false;
          this.notification = not;
        }, 100);
      });
      EventBus.$on('start-loading', not => {
        this.loading = true;
      });
      EventBus.$on('stop-loading', not => {
        setTimeout(() => { // TODO: this shouldnt be needed - loading only appears w/ timeout
          this.loading = false;
        }, 100);
      });
    }
  }
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto');
@import url('https://fonts.googleapis.com/css?family=Roboto+Mono');
  html, body {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  body {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #app {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue